
import { useEffect, useState } from 'react';
import UpdateProduct from './../../../components/monaliza/product/UpdateProduct';
import { useParams } from 'react-router-dom';
import { getProductAsync } from '../../../app/store/reducers/product/productReducer';



const ProductUpdate = () => {
  const {id} = useParams()
  const [product, setProduct] = useState(null)

  const loadProduct = async (id) => {
    await getProductAsync({id})
      .then((response) => {
        setProduct(response)
      })
      .catch((error) => {
        setProduct(null)
      })
  }

  useEffect(() => {
    loadProduct(id)
  },[id])

//   const product = {
//     name: "Test-name",
//     currency_id: "asdf123",
//     amount: 5,
//     category_id: "qqwer123",
//     residual: "10",
//     description: "Hello world",
//     image: {
//       uid: '-1',
//       name: 'image.png',
//       status: 'done',
//       url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
//     },
// }

  if (!product) {
    return <>loading...</>
  }


    return (
    <>
        <UpdateProduct product={product}/>
    </>
  )
}

export default ProductUpdate